import { render } from "./item.vue?vue&type=template&id=63a0488e&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"

import "./item.vue?vue&type=style&index=0&id=63a0488e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a0488e"]])

export default __exports__